import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Input from "../../../../../../../components/Input";
import { getAllDurations } from "./DurationFilter.utils";
import { DateDropdownContainer, InputWrapper } from "../ChartsFilter.component.styles";

function DurationFilter({ timeDuration, setTimeDuration }) {
  const { t } = useTranslation();
  const [dateDropdown, setDateDropdown] = useState(14);
  const allDurations = getAllDurations();

  useEffect(() => {
    try {
      if (dateDropdown) {
        console.log("dateDropdown", dateDropdown, allDurations);
        const selectedDuration = allDurations[dateDropdown - 1];
        if (selectedDuration) {
          setTimeDuration(selectedDuration);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, [dateDropdown]);

  const handleClearAllSelection = () => {};
  const changeDateTypeDropdown = (value) => {
    try {
      handleClearAllSelection();
      setDateDropdown(value);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {
        <DateDropdownContainer>
          <InputWrapper>
            <Input
              options={allDurations}
              type="select"
              as="select"
              showLabel={true}
              label={t("Duration")}
              isValidationError={false}
              value={dateDropdown}
              onChange={(value) => changeDateTypeDropdown(value)}
              sortData={false}
            />
          </InputWrapper>
        </DateDropdownContainer>
      }
    </>
  );
}

export default DurationFilter;
